var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecovery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "recovery"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 15,
    height: 15,
    transform: "translate(39 143)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_627",
    "data-name": "Mask Group 627",
    transform: "translate(-39 -143)",
    clipPath: "url(#recovery)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_70_",
    "data-name": "svgexport-6 (70)",
    transform: "translate(40.408 143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11477",
    "data-name": "Path 11477",
    d: "M8.685,5.8a.351.351,0,0,0-.351.351v6.639a.351.351,0,0,0,.7,0V6.148A.351.351,0,0,0,8.685,5.8Zm0,0",
    transform: "translate(-0.521 -0.362)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11478",
    "data-name": "Path 11478",
    d: "M4.263,5.8a.351.351,0,0,0-.351.351v6.639a.351.351,0,0,0,.7,0V6.148A.351.351,0,0,0,4.263,5.8Zm0,0",
    transform: "translate(-0.244 -0.362)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11479",
    "data-name": "Path 11479",
    d: "M1,4.466v8.655a1.938,1.938,0,0,0,.515,1.337A1.73,1.73,0,0,0,2.768,15H9.414a1.73,1.73,0,0,0,1.255-.543,1.938,1.938,0,0,0,.515-1.337V4.466a1.342,1.342,0,0,0-.344-2.639h-1.8V1.388A1.38,1.38,0,0,0,7.651,0H4.532A1.38,1.38,0,0,0,3.14,1.388v.439h-1.8A1.342,1.342,0,0,0,1,4.466ZM9.414,14.3H2.768A1.113,1.113,0,0,1,1.7,13.121V4.5h8.782v8.624A1.113,1.113,0,0,1,9.414,14.3ZM3.843,1.388A.677.677,0,0,1,4.532.7H7.651a.677.677,0,0,1,.689.685v.439h-4.5Zm-2.5,1.142h9.5a.632.632,0,1,1,0,1.265h-9.5a.632.632,0,1,1,0-1.265Zm0,0",
    transform: "translate(0 0)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11480",
    "data-name": "Path 11480",
    d: "M6.474,5.8a.351.351,0,0,0-.351.351v6.639a.351.351,0,0,0,.7,0V6.148A.351.351,0,0,0,6.474,5.8Zm0,0",
    transform: "translate(-0.383 -0.362)",
    fill: "#6a6f73"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecovery);
export default __webpack_public_path__ + "static/media/recovery.1d06705ef125b0c9f345511c2ca3eab2.svg";
export { ForwardRef as ReactComponent };